import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/articles';

export default function Hero() {
  return (
    <section className="relative w-full min-h-[520px] md:min-h-[600px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20minimalist%20reading%20space%20with%20soft%20natural%20light%2C%20bookshelves%20with%20curated%20books%2C%20cozy%20armchair%2C%20warm%20terracotta%20and%20cream%20tones%2C%20artistic%20abstract%20composition%2C%20soft%20focus%20background%2C%20elegant%20calm%20atmosphere%2C%20no%20people&width=1600&height=900&seq=hero-bg-001&orientation=landscape"
          alt="精选高质量内容推荐平台"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/45"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center py-20">
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight tracking-tight">
          {siteInfo.tagline}
        </h1>
        <p className="text-base md:text-lg text-white/85 max-w-2xl mx-auto mb-10 leading-relaxed">
          {siteInfo.description}
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/all"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 font-medium rounded-full hover:bg-primary-600 transition-all duration-200 text-sm whitespace-nowrap cursor-pointer"
          >
            <i className="ri-compass-3-line text-lg"></i>
            探索精选内容
          </Link>
          <a
            href="#today-picks"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-white/15 backdrop-blur-sm text-white border border-white/25 rounded-full hover:bg-white/25 transition-all duration-200 text-sm whitespace-nowrap cursor-pointer"
          >
            <i className="ri-sparkling-line text-lg"></i>
            今日推荐
          </a>
        </div>
      </div>
    </section>
  );
}